import { IBaseQueryParameters } from '../index.js'

/**
 * This interface defines the query parameters for the endpoints available in
 * the `CongressionalRecord` endpoint class.
 */
export interface ICongressionalRecordQueryParameters extends IBaseQueryParameters {
  /** A 4 digit year in the YYYY format (e.g. `2022`). */
  y?: number

  /** A month specified in the M or MM format (e.g. `5` or `10`) */
  m?: number

  /** A day specified in the D or DD format (e.g. `5` or `10`) */
  d?: number
}
